import FileManager from './FileManager.js';
export default class Storage {
    constructor() {
    }
    save(key, data) {
        return new Promise(function (resolve, reject) {
            var jsonData = JSON.stringify(data);
            try {
                localStorage[key] = jsonData;
            } catch (e) {
                console.warn("save: " + e);
            }
            //save to local file
            var file = new FileManager();
            file.writeFile(key + ".json", jsonData).then(function (message) {
                console.log("FileManager writeFile: " + message);
            }).catch(function (ex) {
                console.warn("FileManager writeFile: " + ex);
            }).finally(function () {
                resolve();
            });
        });
    };
    load(key) {
        return new Promise(function (resolve, reject) {
            var dataRaw = null;
            try {
                dataRaw = localStorage.getItem(key);
            } catch (e) {
                console.warn("load: " + e);
            }

            var data = null;
            if (dataRaw !== null && dataRaw != "{}") {
                try {
                    data = JSON.parse(dataRaw);
                } catch (e) {
                    data = null; //error in the above string(in this case,yes)!
                };
            }
            if (data) {
                resolve(data);
                return;
            }

            //if not data found from local storage try reading from filesystem
            var file = new FileManager();
            file.readFile(key + ".json").then(function (dataRaw) {
                try {
                    data = JSON.parse(dataRaw);
                } catch (e) {
                    data = null; //error in the above string(in this case,yes)!
                };
                resolve(data);
            }).catch(function (ex) {
                resolve(null);
            });
        });
    }
}